import {alias, createModelSchema, identifier, primitive, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";


export class PackageType extends Cloneable {
    static REWARD = new PackageType(1, "REWARD");
    static REWARD_1 = new PackageType(2, "SECCOND");
    static REWARD_2 = new PackageType(3, "THIRD");

    static _values = [
        this.REWARD,
        this.REWARD_1,
        this.REWARD_2
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, PackageType.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof PackageType) {
            return PackageType._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof PackageType) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PackageType());
        } else if (target instanceof PackageType) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PackageType, {
    _id: alias("id", identifier()),
    _name: alias("name", primitive())
});